<template>
  <div class="emailPage">
    <!-- @fetchList="fetchList" -->
    <MenuTemplate
      ref="menuTemplateRef"
      :data="data"
      :isAssigned="isAssigned"
      :disabledPlan="disabledPlan"
      @redirectToList="removeMessage"
    />
    <InboxTemplate
      ref="inboxTemplateRef"
      :data="data"
      @update="
        (event) => {
          fetchList(event);
          fetchMenuList();
        }
      "
      @update:menu="fetchMenuList"
      @toResolved="toResolved"
      :resolveSelected="resolveSelected"
    />
  </div>

  <RestrictionChangePlanModal
    title="Realiza un upgrade y accede a todo el poder de Beex."
    v-model:open="openRestriction"
  >
    <template #description>
      Tu plan {{ PlanTypeText[plan] }} no incluye este módulo.
      Solicita un upgrade tu plan para potenciar tu ambiente de trabajo.
    </template>
  </RestrictionChangePlanModal>
</template>
<script setup lang="ts">
import { ref, provide, computed, onUnmounted, onMounted } from "vue";
import MenuTemplate from "@/app/emails/components/templates/MenuTemplate.vue";
import InboxTemplate from "@/app/emails/components/templates/InboxTemplate.vue";
import { emailService } from "@/app/emails/services/Email.service";
import { DataType, IMenutem } from "@/@types/emails";
import { useStore } from "vuex";
import { UserData } from "@/@types/global";
import { debounce } from "lodash";
import { PlanType, PlanTypeText } from "@/app/common/types";
import { watch } from "vue";
import { ActionPlanStrategy } from "@/app/common/utils/enums";
import RestrictionChangePlanModal from "@/app/common/components/modals/RestrictionChangePlanModal.vue";
import EventBus from "@/app/shared/utils/eventBus";

// const items = ref<IMenutem[]>([]);
// provide("menuItems", items);

const isAssigned = ref(false);
const replyEmail = ref(false);

provide("replyEmail", replyEmail);

// const data = ref<DataType[]>([]);

const store = useStore();

const user = computed<UserData>(() => store.getters["getDataUser"]);
const data = computed(() => store.getters["getThreadsInbox"]);

// const fetchingList = ref(false);

const menuTemplateRef = ref<InstanceType<typeof MenuTemplate>>();
const inboxTemplateRef = ref<InstanceType<typeof InboxTemplate>>();

const resolveSelected = computed(() => menuTemplateRef.value?.resolveSelected ?? false);

// const filterRead = ref<boolean | "">("");
// const filterSelectedTags = ref<Array<number | "">>([""]);
// const filterSearch = ref<string | null>(null);

// const channelCustomerId = ref(null);

// const fetchingList = computed(() => store.getters["getFetchingThreadsInbox"]);

// provide("fetchingList", fetchingList);
/*
  #TODO: Cambiar estructura de filtros de inbox para que use estados. 
  Usar vuex para estos valores ya que el listado del inbox depende de estos
*/
// provide("filterSearch", filterSearch);
// provide("filterRead", filterRead);
// provide("filterSelectedTags", filterSelectedTags);

/*
  #TODO: Mejorar acción SET_THREADS_INBOX, deberia tomar todos los valores necesarios de state y query
  Para poder actualizar el listado de inbox de una manera más rápida desde acciones como resolver, transferir,
  mover, asignar, etc, ya que actualmente el código es muy engorroso y dificulta agregar parametros a la petición.
*/
const fetchList = debounce(
  // async (query: {
  //   channelCustomerId?: number;
  //   assigned: boolean;
  //   resolved?: boolean;
  //   read?: boolean;
  //   tagList?: number[];
  //   page?: number;
  //   resetPagination?: boolean;
  // }) => {
  async () => {
    // fetchingList.value = true;

    // const assignedUser = query?.assigned ? user.value?.id : undefined;
    // channelCustomerId.value = query.channelCustomerId;
    // store.commit("SET_THREADS_INBOX", []);
    await store.dispatch("updateThreadsInbox", {
      // ...query,
      // assignedUser: assignedUser,
      assignedUser: user.value?.id,
      resetPagination: true,
    });
    // const response = await emailService.getInboxList(
    //   !query.assigned,
    //   query.channelCustomerId,
    //   assignedUser,
    //   query.resolved,
    //   query.read,
    //   query.tagList,
    //   query.assigned ? 2 : 1
    // );
    // data.value = response.results;

    // fetchingList.value = false;
  },
  100
);

const toResolved = () => {
  menuTemplateRef.value?.showResolveEmail();
};

provide("fetchList", fetchList);

const fetchMenuList = () => {
  console.log("fetchMenuList");
  menuTemplateRef.value?.fetchMenuList();
};

const handleButtonMenuList = (item: any, subItem: any, fromMenu?: boolean) => {
  menuTemplateRef.value?.handleButtonClick(item, subItem, fromMenu);
};

provide("handleButtonMenuList", handleButtonMenuList);

const removeMessage = () => {
  console.log("remove message");
  inboxTemplateRef.value?.removeMessage();
};

const plan = computed(() => user.value?.change_custom_plan?.plan);
const openRestriction = ref(false);

const disabledPlan = ref(false);

const validateActionPlanHeader = () => {
  console.log("validateActionPlanHeader", plan.value);
  if (plan.value == PlanType.Voice) {
    store.commit("SET_ACTION_PLAN_HEADER", ActionPlanStrategy.Upgrade);
    disabledPlan.value = true;
  } else {
    store.commit("SET_ACTION_PLAN_HEADER", null);
    disabledPlan.value = false;
  }
};

EventBus.on("SHOW_RESTRICTION_PLAN", () => {
  openRestriction.value = true
});

watch(user, () => {
  validateActionPlanHeader();
});

watch(plan, () => {
  validateActionPlanHeader();
})

onMounted(() => {
  validateActionPlanHeader();
})

onUnmounted(() => {
  store.commit("SET_ACTION_PLAN_HEADER", null);
});

</script>
<style lang="sass" scoped>
.emailPage
  background-color: #FFFFFF
  min-height: 100%
  max-height: 100%
  height: 100%
  display: flex
  .menu
    width: 20%
    z-index: 2
  .inbox
    width: 80%
</style>
